import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import VirtualTourSteps from '../../VirtualTourSteps';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import * as media from '../../../constants/mediaQueries';

const VirtualTourRightPart = (props) => {
  const { selectedLocations } = props;

  return (
    <div className="virtual-page__side-block">
      <div className="col-md-3">
        <div className="row">

          <MediaQuery minWidth={media.SCREEN_MD_MIN}>
            <div className="col-sm-6 col-md-12">
              {(selectedLocations.length > 0) && <OrderForm noScroll />}
            </div>
          </MediaQuery>

          <div className="col-sm-6 col-md-12">
            <VirtualTourSteps />
          </div>

        </div>
      </div>
    </div>
  );
};

VirtualTourRightPart.propTypes = {
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

VirtualTourRightPart.defaultProps = {
  selectedLocations: [],
};

export default VirtualTourRightPart;
